import { applyFilters, doRequest } from "./helpers";

export default class CustomTableService {
  static async list(filters = null, { suppressForbiddenModal } = {}) {
    let path = "/custom_tables/";
    path = applyFilters(filters, path);
    return doRequest("GET", path, { suppressForbiddenModal });
  }

  static async get(slug) {
    return doRequest("GET", `/custom_tables/${slug}`);
  }

  static async create(data) {
    return doRequest("POST", "/custom_tables/", { data });
  }

  static async update(slug, data) {
    return doRequest("PUT", `/custom_tables/${slug}`, { data });
  }

  static async delete(slug) {
    return doRequest("DELETE", `/custom_tables/${slug}`);
  }

  static async addColumn(slug, data) {
    return doRequest("POST", `/custom_tables/${slug}/columns`, { data });
  }

  static async updateColumn(slug, fieldId, data) {
    return doRequest("PUT", `/custom_tables/${slug}/columns/${fieldId}`, {
      data,
    });
  }

  static async deleteColumn(slug, fieldId) {
    return doRequest("DELETE", `/custom_tables/${slug}/columns/${fieldId}`);
  }

  static async reorderColumns(slug, fieldIds) {
    return doRequest("PUT", `/custom_tables/${slug}/columns/order`, {
      data: { field_ids: fieldIds },
    });
  }

  static async getInboundRelationships(slug) {
    return doRequest("GET", `/custom_tables/${slug}/inbound_relationships`);
  }

  static async getLinkedTables(targetType, recordId) {
    let path = "/custom_tables/linked_tables";
    path = applyFilters({ target_type: targetType, record_id: recordId }, path);
    return doRequest("GET", path);
  }

  static async listPermissions(slug) {
    return doRequest("GET", `/custom_tables/${slug}/permissions`);
  }

  static async updatePermission(slug, roleId, data) {
    return doRequest("PUT", `/custom_tables/${slug}/permissions/${roleId}`, {
      data,
    });
  }
}
